import { EnvKeys } from "./consts";
import { getEnvValue } from "./helpers";

/**
 * Hardcoded list of SSO domains - can also be loaded from env
 */
const SSO_DOMAINS_ARRAY = ["legaleaseplan.com"];

/**
 * Gets the list of SSO domains
 * Can be overridden by REACT_APP_SSO_DOMAINS env variable
 */
export const getSSODomains = (): string[] => {
	const domainsString = getEnvValue(EnvKeys.SSODomains);
	if (domainsString) {
		return domainsString
			.split(",")
			.map((domain) => domain.trim().toLowerCase())
			.filter((domain) => domain.length > 0);
	}

	return SSO_DOMAINS_ARRAY;
};

/**
 * Checks if an email address belongs to an SSO domain
 * @param email - The email address to check
 * @returns true if the email domain is configured for SSO
 */
export const isSSODomain = (email: string): boolean => {
	if (!email || !email.includes("@")) return false;

	const domain = email.split("@")[1]?.toLowerCase();
	if (!domain) return false;

	const ssoDomains = getSSODomains();
	return ssoDomains.includes(domain);
};

/**
 * Extracts domain from email address
 * @param email - The email address
 * @returns the domain part of the email or empty string
 */
export const getDomainFromEmail = (email: string): string => {
	if (!email || !email.includes("@")) return "";
	return email.split("@")[1]?.toLowerCase() || "";
};
